/**
 * Based off Zendesk Utilities Library
 * Original License - Apache-2.0
 * https://github.com/zendeskgarden/react-containers/blob/main/packages/utilities/src/utils/composeEventHandlers.ts
 *
 * We are using the .some() array method to iterate through all
 * the provided functions and stop if defaultPrevented is true.
 *
 */
// eslint-disable-next-line @typescript-eslint/ban-types
export function composeEventHandlers(...fns: (Function | undefined)[]) {
    return (event: any, ...args: any[]): boolean =>
        fns.some((fn) => {
            fn?.(event, ...args);

            return event?.defaultPrevented;
        });
}
